module.exports = __webpack_public_path__ + "static/img/logo.066fde8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new2/logo.png
// module id = pM9B
// module chunks = 1